<template>
  <v-dialog
    v-model="open"
    width="290"
    style="overflow: auto; -webkit-overflow-scrolling: touch"
    @keydown.esc="cancel"
  >
    <v-card class="pa-2">
      <v-card-title class="card-title" v-text="title" />
      <v-card-text v-text="text" />
      <v-card-actions>
        <v-spacer />
        <v-btn
          ref="deleteButton"
          color="primary"
          class="elevation-0"
          dark
          @click.native="confirm"
        >
          {{ confirmTitle }}
        </v-btn>
        <v-btn ref="cancelButton" color="rubber" outline @click.native="cancel">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-progress-linear v-if="loading" class="ma-0" indeterminate />
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    confirmTitle: {
      type: String,
      default: "Confirm",
    },
    title: {
      type: String,
      default: "Delete",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "Are you sure?",
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      open: this.value,
    };
  },
  watch: {
    value: {
      handler() {
        this.open = this.value;
      },
    },
    open: {
      handler() {
        if (this.open) {
          return;
        }
        this.cancel();
      },
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>
